import { SHIFTTYPE_COMPANY } from "../actions/types";

const initialState = {
  createShiftTypeCompany: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },

  getShiftTypeCompanies: {
    shiftTypeCompanies: {},
    isFetching: false,
    errorMessage: null,
  },

  getShiftTypeCompany: {
    shiftTypeCompany: {},
    isFetching: false,
    errorMessage: null,
  },

  updateShiftTypeCompany: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },

  deleteShiftTypeCompany: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    // #region SHIFT.CREATE

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_CREATE_REQUEST:
      return {
        ...state,
        createShiftTypeCompany: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_CREATE_SUCCESS:
      return {
        ...state,
        createShiftTypeCompany: {
          successMessage: "Dienstsoortprijs voor bedrijf toevoegen is gelukt.",
          errorMessage: null,
          isFetching: false,
        },
      };

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_CREATE_FAIL:
      return {
        ...state,
        createShiftTypeCompany: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region SHIFTTYPE.GET_SHIFTTYPES

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_GET_SHIFTTYPE_COMPANIIES_REQUEST:
      return {
        ...state,
        getShiftTypeCompanies: {
          shiftTypeCompanies: {},
          isFetching: true,
          errorMessage: null,
        },
      };

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_GET_SHIFTTYPE_COMPANIIES_SUCCESS:
      return {
        ...state,
        getShiftTypeCompanies: {
          shiftTypeCompanies: action.payload,
          isFetching: false,
          errorMessage: null,
        },
      };

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_GET_SHIFTTYPE_COMPANIIES_FAIL:
      return {
        ...state,
        getShiftTypeCompanies: {
          shiftTypeCompanies: {},
          isFetching: false,
          errorMessage: action.payload,
        },
      };

    // #endregion

    // #region SHIFTTYPE_COMPANY.GET

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_GET_REQUEST:
      return {
        ...state,
        getShiftTypeCompany: {
          shiftTypeCompany: {},
          isFetching: true,
          errorMessage: null,
        },
      };

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_GET_SUCCESS:
      return {
        ...state,
        getShiftTypeCompany: {
          shiftTypeCompany: action.payload,
          isFetching: false,
          errorMessage: null,
        },
      };

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_GET_FAIL:
      return {
        ...state,
        getShiftTypeCompany: {
          shiftTypeCompany: {},
          isFetching: false,
          errorMessage: action.payload,
        },
      };

    // #endregion

    // #region SHIFTTYPE_COMPANY_UPDATE

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_UPDATE_REQUEST:
      return {
        ...state,
        updateShiftTypeCompany: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_UPDATE_SUCCESS:
      return {
        ...state,
        updateShiftTypeCompany: {
          successMessage: "Bijwerken is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_UPDATE_FAIL:
      return {
        ...state,
        updateShiftTypeCompany: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region SHIFTTYPE_COMPANY_DELETE

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_DELETE_REQUEST:
      return {
        ...state,
        deleteShiftTypeCompany: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_DELETE_SUCCESS:
      return {
        ...state,
        deleteShiftTypeCompany: {
          successMessage:
            "Dienstsoortprijs voor bedrijf verwijderen is voltooid",
          errorMessage: null,
          isFetching: false,
        },
      };

    case SHIFTTYPE_COMPANY.SHIFTTYPE_COMPANY_DELETE_FAIL:
      return {
        ...state,
        deleteShiftTypeCompany: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/shiftTypeCompanyReducer.js